import { LEVEL_META } from "@/lib/format";

const STATE_STYLES = {
  concluido: "border-chessup-gold/60 bg-chessup-gold/10 text-chessup-goldlight",
  atual: "border-chessup-turq bg-chessup-turq/10 text-chessup-turq animate-pulse-glow",
  disponivel: "border-chessup-border bg-chessup-card text-chessup-text",
  bloqueado: "border-chessup-border/40 bg-chessup-deep/60 text-chessup-subtext/50",
};

export default function LevelBadge({ levelKey, state = "disponivel", size = 64 }) {
  const meta = LEVEL_META[levelKey] || LEVEL_META.pawn;
  return (
    <div
      className={`flex flex-col items-center justify-center rounded-2xl border ${STATE_STYLES[state]} transition-all`}
      style={{ width: size, height: size }}
      data-testid={`level-badge-${levelKey}`}
    >
      <span style={{ fontSize: size * 0.42, lineHeight: 1 }}>{meta.piece}</span>
    </div>
  );
}
